const complexTabs = {
	HOME: 'home',
	FACTORY: 'machines'
};

export default complexTabs;